import React from "react";
import { FeedStackSection } from "src/components/FeedContainer";
import { TaskBox } from "src/components/Tasks";

export const ContentSectionBelowLg = () => {
  return (
    <FeedStackSection
      renderContent={(row, index) => <TaskBox key={index} row={row} />}
    />
  );
};
